<template>
  <v-fade-transition appear>
    <v-app>
      <v-navigation-drawer v-model="pageState.menuVisible" mobile-break-point="1024" app>
        <v-list dense nav>
          <v-list-item link to="/home">
            <v-list-item-content>
              <v-list-item-title>รายงานผลการแจ้งซ่อม</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/repair">
            <v-list-item-content>
              <v-list-item-title>งานซ่อมทั้งหมด</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar app>
        <v-app-bar-nav-icon
          v-if="$vuetify.breakpoint.width < 1024 || pageState.shouldHideSidebar"
          @click.stop="pageState.menuVisible = !pageState.menuVisible"
        ></v-app-bar-nav-icon>
        <v-toolbar-title>
          <span>{{"CVC "}}</span>
          <span class="font-weight-light">IT support - Admin Control Panel</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y v-if="user">
          <template v-slot:activator="{ on }">
            <v-btn text icon v-on="on">
              <v-avatar size="36">
                <img :src="user.photoURL" alt="avatar" />
              </v-avatar>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{user.displayName}}</v-list-item-title>
                <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item @click="logout">
              <v-list-item-title>ออกจากระบบ</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-content fill-height>
        <global-snack-bar />
        <router-view />
      </v-content>
    </v-app>
  </v-fade-transition>
</template>

<script>
import SnackBar from "./components/SnackBar";

import { mapState } from "vuex";

export default {
  name: "App",
  data: () => ({
    pageState: {
      menuVisible: true
    }
  }),
  components: {
    globalSnackBar: SnackBar
  },
  methods: {
    logout() {}
  },
  computed: mapState(["user"])
};
</script>
